export default "__VITE_ASSET__Cd5qFBsc__"